import React from 'react';
export function CreatorSection() {
  return <section className="w-full py-24 px-4 bg-cream text-navy" data-id="element-2">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-12 md:gap-16" data-id="element-3">
        {/* Left Column - Image & Badges */}
        <div className="w-full md:w-5/12 flex flex-col items-center text-center" data-id="element-4">
          <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full bg-navy flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(201,168,76,0.3)] border-4 border-gold overflow-hidden" data-id="element-5">
            <img src="https://i.pravatar.cc/400?img=47" alt="Serena Voss" className="w-full h-full object-cover" data-id="element-6" />
            {/* Subtle glowing ring */}
            <div className="absolute inset-[-10px] rounded-full border border-gold/30 animate-pulse-glow pointer-events-none" data-id="element-7"></div>
          </div>

          <h3 className="font-serif text-3xl font-bold mb-2" data-id="element-8">Serena Voss</h3>
          <p className="text-navy/70 text-sm uppercase tracking-wider font-semibold mb-8" data-id="element-9">
            Spiritual Guide & Energy Clearing Practitioner
          </p>

          <div className="flex flex-col space-y-4 w-full max-w-sm text-left" data-id="element-10">
            <div className="flex items-center space-x-3 bg-white/50 p-3 rounded-lg" data-id="element-11">
              <span className="text-xl" data-id="element-12">✨</span>
              <span className="text-sm font-medium" data-id="element-13">
                Certified Energy Clearing Practitioner
              </span>
            </div>
            <div className="flex items-center space-x-3 bg-white/50 p-3 rounded-lg" data-id="element-14">
              <span className="text-xl" data-id="element-15">🔮</span>
              <span className="text-sm font-medium" data-id="element-16">
                12+ Years Guiding Women Through Frequency Work
              </span>
            </div>
            <div className="flex items-center space-x-3 bg-white/50 p-3 rounded-lg" data-id="element-17">
              <span className="text-xl" data-id="element-18">🌙</span>
              <span className="text-sm font-medium" data-id="element-19">
                Creator of The Lucky Flush Protocol
              </span>
            </div>
          </div>
        </div>

        {/* Right Column - Copy */}
        <div className="w-full md:w-7/12 flex flex-col" data-id="element-20">
          <p className="text-gold-dark text-sm tracking-[0.15em] font-bold uppercase mb-4" data-id="element-21">
            A NOTE FROM THE CREATOR
          </p>

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight mb-8" data-id="element-22">
            I Spent 12 Years Trying To Understand Why Some People Seem To
            Attract Good Things — And Others Repel Them
          </h2>

          <div className="space-y-6 text-lg text-navy/80 leading-relaxed" data-id="element-23">
            <p data-id="element-24">
              My name is Serena Voss, and I was not always someone who believed
              in energy clearing.
            </p>
            <p data-id="element-25">
              I came from a deep personal journey through energy work and
              spiritual practice. I spent years studying how specific audio
              frequencies affect the nervous system, emotional regulation, and
              decision-making patterns.
            </p>
            <p data-id="element-26">
              But it wasn't until I started working with women who described
              feeling 'cursed' or 'stuck in a bad luck cycle' that I found the
              connection no one was talking about:
            </p>
            <p className="italic font-serif text-xl text-navy font-medium border-l-4 border-gold pl-6 my-8" data-id="element-27">
              Chronic stress, emotional residue, and what many cultures call
              'the evil eye' all create measurable interference patterns in the
              body's bioelectric field.
            </p>
            <p data-id="element-28">
              The Lucky Flush Protocol was born from 7 years of client sessions,
              frequency research, and the simple observation that when we remove
              the interference — the 'luck' returns. Not because of magic.
              Because the signal is finally clear.
            </p>
          </div>
        </div>
      </div>
    </section>;
}